import script from "./NotificationDetailView.vue?vue&type=script&setup=true&lang=js"
export * from "./NotificationDetailView.vue?vue&type=script&setup=true&lang=js"

import "./NotificationDetailView.vue?vue&type=style&index=0&id=c64d6580&scoped=true&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-c64d6580"]])

export default __exports__